import env from '../../../../config/environment'

angular.module('eficienciaFiscalModule')
    .service('pathService', [
        '$filter', function($filter) {
            var urlView = '/app/module/';
            var urlDomain = window.location.protocol + '//' + window.location.hostname;

            this.getViewUrl = function() {
                return urlView;
            };

            this.getApiUrl = function() {
                return env.api_url;
            };

            var formatParam = function(value, params, key, concat) {
                concat = concat || '';
                var keyName = concat.length > 0 ? (concat + '[' + key + ']') : key;

                if ((typeof value == "object" && value !== null) || (typeof value != "object" && value != undefined && !(typeof value == 'string' && value == ''))) {
                    if (Array.isArray(value))
                        value.inject(function(params, value, key) {
                            return formatParam(value, params, keyName + '[]');
                        }, params);
                    else
                        if (typeof value == "object")
                            if (value.constructor == Date)
                                params.push(keyName + '=' + $filter('date')(value, 'yyyy-MM-dd'));
                            else
                                params = value.inject(function(params, value, childKey) {
                                    return formatParam(value, params, childKey, keyName);
                                }, params);
                        else
                            params.push(keyName + '=' + value);
                }
                return params;
            };

            this.toParams = function(params) {
                return params.inject(function(params, value, key) {
                    return formatParam(value, params, key);
                }, []).join('&');
            };

            this.parametrize = function(url, params) {
                params = this.toParams(params);
                return url + (params.length > 0 ? '?' + params : '');
            };

            this.urlDomain = urlDomain;
        }
    ]);
